'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { ToggleCardRootContext } from './context/toggle-card-root.context';
import { toggleCardTriggerRecipe } from './styles/toggle-card-root-trigger.styles';
import type { ToggleCardRootTriggerPropsInterface } from './types/toggle-card-root-trigger.types';

/**
 * Stretched toggle button for `ToggleCard.Root`. Selection state, variants and
 * the accessible name are resolved by Root.
 */
export const ToggleCardRootTrigger = forwardRef<
  HTMLButtonElement,
  ToggleCardRootTriggerPropsInterface
>((props: ToggleCardRootTriggerPropsInterface, forwardedRef) => {
  const { className, css: cssProp, ...rest } = props;

  const { triggerProps, rootProps } = useContext(ToggleCardRootContext);

  const styles = css(toggleCardTriggerRecipe.raw(rootProps), cssProp);

  return (
    <button
      ref={forwardedRef}
      data-c11n-component="ToggleCard.RootTrigger"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_toggle-card__root-trigger', styles, className)}
      {...rest}
      type="button"
      aria-pressed={rootProps.selected}
      disabled={rootProps.disabled}
      {...triggerProps}
    />
  );
});

ToggleCardRootTrigger.displayName = 'ToggleCard.RootTrigger';
